// extracted by mini-css-extract-plugin
export default {"relatedSearchPill":"SjnHT"};